<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='3'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">商品收藏</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <div class="cght_ddgltop">
              <ul class="cght_ddglnavula">
                <li><a class="cght_ddglnavulaxz">商品</a></li>
              </ul>
              <!-- <div class="cght_ddglright">
                <div class="cght_ddglrightr"><div><em><input type="text" /></em><a href="#"></a></div></div>
              </div> -->
            </div>
            <div class="cght_spsctibt" v-if="list.length">
              <div class="cght_spsctibtl">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              </div>
              <div class="cght_spsctibtl cght_spsctibtla"><a href="javascript:;" @click="delCollect">取消收藏</a></div>
              <!--  <div class="cght_spsctibtl cght_spsctibtlem"><em>忘了选商品了？</em></div> -->
            </div>
            <ul class="cght_spscpicul qlnomar5" v-loading="qyloading" v-if="list.length">
              <li class="cght_showhidety2 this_page_css" v-for="(item,index) in list" :key="index">
                <div class="cght_spscpicul1">
                  <router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">
                    <img v-real-img="item.imgpath" width="150" height="150" :alt="item.title" src="../../assets/images/zwtp.jpg"/>
                  </router-link>
                  <!--<div class="cght_spscpicul1a cght_spscpicul1agy cght_showhidetye2">加入购物车</div>-->
                  <div class="cght_spscpicul1b" v-show="item.cancel">
                    <div class="cght_spscpicul1ba">确定取消收藏？</div>
                    <div class="cght_spscpicul1bb"><em @click="aloneDel(item.id)">确定</em><span @click="cancelCollect(index)">取消</span></div>
                  </div>
                </div>
                <div class="cght_spscpicul2">
                  <em>
                    <el-checkbox v-model="item.checkType" @change="handleCheckedCitiesChange(item,index)"></el-checkbox>
                  </em>
                  <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">{{item.title}}</router-link></h3>
                </div>
                <div style="overflow: hidden;">
                  <div class="cght_spscpicul3" style="float: left;" v-if="item.tax_price > 0">￥{{item.tax_price}}</div>
                  <div class="cght_spscpicul3" style="float: left;" v-else>询价</div>
                  <div class="cght_spscpicul5" style="float: right;" @click="cancelCollect(index)"><em>取消</em></div>
                </div>
              </li>
            </ul>
            <div class="cght_meiyoudingdansc" v-if="isLoading&&list.length==0">
              <div class="cght_meiyoudingdanscd">
                <em>您还没有收藏过任何商品哦~</em>
                <router-link :to="{path:'/'}" class="cght_meiyoudingdanscda">去首页看看</router-link>
              </div>
            </div>
            <div class="cght_height16"></div>
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
            <!-- <div class="ql_fenye cght_fenye">
              <div class="cght_spsctibtl"><label ><input type="checkbox" class="qxan"/>&emsp;全选</label></div>
              <div class="cght_spsctibtl cght_spsctibtla"><a href="javascript:;">取消关注</a></div>
              <div class="cght_spsctibtl cght_spsctibtlem"><em>忘了选商品了？</em></div>
              <div class="cght_spsctibtr">
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/user'
export default {
  name: 'Collect',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      qyloading: false,
      isLoading: false,
      checkedArr: [],
      checkAll: false,
      isIndeterminate: true,
      listQuery: {
        limit: 30
      },
      id_list: []
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    LoadData () {
      this.qyloading = true // 页面区域loading
      this.api.getMyLike(this.listQuery).then(response => {
        let forlist = response.items
        forlist.forEach(res => {
          res.cancel = false
          res.checkType = false
        })
        this.id_list = response.id_list
        this.list = forlist
        this.total = response.total
        this.isLoading = true
        this.qyloading = false
      })
    },
    cancelCollect (index) {
      this.list[index].cancel = !this.list[index].cancel
    },
    aloneDel (id) {
      api.delCollect({id_list: id}).then(res => {
        this.listQuery.page = 1
        this.LoadData()
      })
    },
    delCollect () {
      if (this.checkedArr.length < 1) {
        this.$message.error('请先选择要取消收藏的产品')
        return
      }
      this.$confirm('是否取消所选的收藏产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delCollect({id_list: this.checkedArr}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {
      })
    },
    handleCheckAllChange () {
      this.isIndeterminate = false
      if (this.checkAll) {
        this.list.forEach(res => { res.checkType = true })
        this.checkedArr = this.id_list
      } else {
        this.list.forEach(res => { res.checkType = false })
        this.checkedArr = []
      }
    },
    handleCheckedCitiesChange (item, index) {
      if (item.checkType) {
        this.checkedArr.splice(index, 0, item.id)
      } else {
        this.checkedArr.splice(this.checkedArr.indexOf(item.id), 1)
      }
      if (this.list.length === this.checkedArr.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    }
  }
}
</script>
<style scoped>
  .this_page_css {
    border-radius:5px ;
    margin: 15px 3px 0 3px;
    padding: 10px 3px 10px 3px;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
  }
  .this_page_css:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .cght_spscpicul2{
    height: 45px;
  }
  .cght_spscpicul2 h3{
    height: 45px;
    line-height: 20px;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .cght_spscpicul li{
    height: 225px;
  }
  .cght_meiyoudingdansc{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/collect.vue